import React from 'react';
import { Label,  ErrorMessage , DatePickerField} from '../FormikCustom';

export default function DateTime({ name, label, required, ...rest }) {
  return (
    <div className="form-group">
      <Label required={required} htmlFor={name}>{label}</Label>
      <DatePickerField name={name} {...rest} className="form-control"  />                                            
      <ErrorMessage name={name} />
    </div>
  );
}
